import axios from "axios";
import React, { useCallback } from "react";

import MonitorLineChart, { MONITOR_DEFAULT_INTERVAL_OPTIONS } from "./MonitorLineChart";
import {
  formatIncomingData,
  MONITOR_HISTORY_RANGE_OPTIONS,
} from "../utils/monitorChartUtils";

export default function UptimeChart({ deviceUuid }) {
  const loadChartState = useCallback(
    async ({ deviceUuid: id, timestampISO, interval }) => {
      const qp = new URLSearchParams({
        interval: String(interval),
        timestamp: timestampISO,
      });
      const response = await axios.get(`/device/${id}/uptime?${qp.toString()}`);
      const rows = response?.data?.uptimes;
      if (!Array.isArray(rows) || rows.length === 0) return { data: [], errorAreas: [] };
      return formatIncomingData(rows);
    },
    []
  );

  return (
    <MonitorLineChart
      deviceUuid={deviceUuid}
      loadChartState={loadChartState}
      showHistory
      showInterval
      defaultHistory="1h"
      historyOptions={MONITOR_HISTORY_RANGE_OPTIONS}
      intervalOptions={MONITOR_DEFAULT_INTERVAL_OPTIONS}
      defaultInterval="5m"
      initialLoading={false}
    />
  );
}
